export enum TabsVariant {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

export type TabsDataType<TId extends string | number = number> = {
  id: TId;
  name: string;
};

export type TabsTypeProps<TId extends string | number = number> = {
  tabs: Array<TabsDataType<TId>>;
  activeTab: TId;
  onTabChange: (id: TId) => void;
  variant?: TabsVariant;
  isDropdownOpen?: boolean;
  setIsDropdownOpen?: (dropdownOpen: boolean) => void;
};

export type TabTypeProps<TId extends string | number = number> = {
  id: TId;
  label: TabsDataType<TId>['name'];
  isActive: boolean;
  variant?: TabsVariant;
  onTabChange: (id: TId) => void;
};
